import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import "./style.scss";

export default observer(function ProgressBar({
  calculatePercentProgress,
  countCard,
  totalCards,
  isLoading,
}) {
  ProgressBar.propTypes = {
    calculatePercentProgress: PropTypes.func,
    countCard: PropTypes.number,
    totalCards: PropTypes.number,
    isLoading: PropTypes.bool,
  };
  return (
    <div className="in-game-page__main__progress-bar-wrapper">
      <div className="in-game-page__main__progress-bar-wrapper__progress-bar">
        <div
          className="in-game-page__main__progress-bar-wrapper__progress-bar__filler"
          style={{
            width: `${calculatePercentProgress()}%`,
          }}
        />
      </div>
      <div className="in-game-page__main__progress-bar-wrapper__count-cards">
        {/* item 3c: пока колода грузится (totalCards=0) показывали «1/0» — держим
            счётчик пустым до готовности карт, а не печатаем нулевой знаменатель.
            Плюс ждём isLoading: колода приходит РАНЬШЕ истории ответов, и в это окно
            countCard ещё 0 → мелькало «1 / 57», а затем прыгало на реальную карту
            (ровно симптом «начинается сначала, потом перепрыгивает»). На быстром канале
            это ~0.5с, на медленном мобильном — секунды. isCardsLoading снимается в
            .finally() ПОСЛЕ getGameHistory, поэтому он и есть точный признак готовности. */}
        {totalCards && !isLoading
          ? `${Math.min(countCard + 1, totalCards)} / ${totalCards}`
          : ""}
      </div>
    </div>
  );
});
